import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import BroadcastTitle from './components/title';
import BroadcastUrl from './components/url';
import BroadcastMessage from './components/message';
import BroadcastDuration from './components/duration';
import { createBroadcast, fetchBroadcast, stopBroadcastAction } from './broadcastActions';
import { clearBroadcast } from './broadcastSlice';

import BroadcastFAQ from 'app/scripts/components/common/faqs/broadcast';
import { ERROR, LOADING, SUCCESS } from 'app/scripts/models/request-status';
import ConfirmModal from 'app/scripts/components/modals/confirm';
import Modal from 'utils/components/modal';
import { minutesToTimer } from 'utils/pretty-timer';
import Icon from 'utils/components/icon';

const NO_TIME_LEFT = '0h 0m';

class BroadcastComponent extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      error: null
    };
  }

  componentDidMount() {
    if (!this.props.broadcast) {
      this.props.fetchBroadcast();
    }
  }

  isValid() {
    var { title, url, message } = this.refs;
    var isValid = title.isValid() && url.isValid() && message.isValid();
    return isValid;
  }

  componentWillUnmount() {
    if (this.timerId) {
      clearInterval(this.timerId);
      this.timerId = false;
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    var oldStatus = this.props.status;
    var newStatus = nextProps.status;
    var broadcast = nextProps.broadcast;
    var { spotId } = this.props;

    if (spotId !== nextProps.spotId) {
      clearInterval(this.timerId);
      this.timerId = false;
      this.props.fetchBroadcast();
    }
    if (broadcast && broadcast.isRunning && !this.timerId) {
      this.timerId = setInterval(() => {
        this.props.fetchBroadcast();
      }, 5000);
    }
    if (this.timerId && broadcast && broadcast.isRunning === false) {
      clearInterval(this.timerId);
      this.timerId = false;
    }
    if (oldStatus !== newStatus) {
      if (newStatus === ERROR) {
        window.scroll(0, 0);
        this.setState({ error: true });
      } else if (newStatus === SUCCESS) {
        this.setState({ error: false });
      }
    }
  }

  stopBroadcast() {
    this.props.stopBroadcast(this.props.broadcast.id);
  }

  newBroadcast() {
    this.props.newBroadcast();
  }

  broadcast() {
    const { title, url, message, duration } = this.refs;

    this.props.sendBroadcast({
      title: title.getValue(),
      url: url.getValue(),
      duration: duration.getValue(),
      text: message.getValue()
    });
  }

  closeConfirmationModal() {
    this.refs.confirmationModal.hide();
  }

  openConfirmModal() {
    var isValid = this.isValid();
    if (isValid) {
      this.refs.confirmationModal.show();
    } else {
      window.scroll(0, 0);
      this.setState({ error: true });
    }
  }

  closeStopModal() {
    this.refs.stopModal.hide();
  }

  openStopModal() {
    this.refs.stopModal.show();
  }

  handleClick() {
    this.broadcast();
    this.refs.confirmationModal.hide();
  }

  handleStopClick() {
    this.stopBroadcast();
    this.refs.stopModal.hide();
  }

  renderTitle() {
    var component = null;
    var { broadcast } = this.props;
    var isRunning = broadcast && broadcast.isRunning;

    if (broadcast) {
      const mobileStatistics = broadcast.statistics.mobile;
      const desktopStatistics = broadcast.statistics.desktop;

      // Render live broadcast
      if (isRunning) {
        component = (
          <div>
            <div style={{ marginTop: 36 }}>
              <span className="title live">Broadcast Is Now Live</span>
              <button className="stop-button" onClick={this.openStopModal.bind(this)}>
                Stop Broadcast
              </button>
            </div>
            <div className="satistic">
              <div>
                <Icon name="time" className="time-live-icon statistic-icon" />
                <span className="satistic-text">
                  <strong>{broadcast.timeLeft} </strong> left
                </span>
              </div>
              <div>
                <Icon name="web" className="web-live-icon statistic-icon" />
                <span className="satistic-text">
                  <strong>{desktopStatistics.views} </strong>
                  <span className="middle-dot-after">views</span>
                  <strong>{desktopStatistics.clicks}</strong> clicks
                </span>
              </div>
              <div className="last">
                <Icon name="mobile" className="mobile-live-icon statistic-icon" />
                <span className="satistic-text">
                  <strong> {mobileStatistics.views} </strong>
                  <span className="middle-dot-after">views</span>
                  <strong>{mobileStatistics.clicks}</strong> clicks
                </span>
              </div>
            </div>
          </div>
        );
        // Render completed broadcast
      } else if (broadcast.timeLeft === NO_TIME_LEFT) {
        component = (
          <div>
            <div style={{ marginTop: 36 }}>
              <button className="new-button" onClick={this.newBroadcast.bind(this)}>
                New Broadcast
              </button>
              <span className="title">{'Summary for ' + broadcast.startedAt}</span>
            </div>
            <div className="satistic">
              <div>
                <Icon name="time" className="time-complete-icon statistic-icon" />
                <span className="satistic-text">
                  <strong>{minutesToTimer(broadcast.duration)} </strong> elapsed
                </span>
              </div>
              <div>
                <Icon name="web" className="web-complete-icon statistic-icon" />
                <span className="satistic-text">
                  <strong>{desktopStatistics.views} </strong>
                  <span className="middle-dot-after">views</span>
                  <strong>{desktopStatistics.clicks}</strong> clicks
                </span>
              </div>
              <div className="last">
                <Icon name="mobile" className="mobile-complete-icon statistic-icon" />
                <span className="satistic-text">
                  <strong> {mobileStatistics.views} </strong>
                  <span className="middle-dot-after">views</span>
                  <strong>{mobileStatistics.clicks}</strong> clicks
                </span>
              </div>
            </div>
          </div>
        );
      }
    } else {
      // Render a new broadcast
      component = <div className="title">Broadcast Details</div>;
    }
    return component;
  }

  renderErrorMessage() {
    if (this.props.reason === 'could not extract url') {
      return <div className="error-message">Could not extract data from URL.</div>;
    } else {
      return <div className="error-message">Please fill in the missing fields below.</div>;
    }
  }

  render() {
    var { status, broadcast } = this.props;
    var { error } = this.state;
    var fieldsClassName = 'fields';
    var title,
      url,
      message,
      duration = '';

    if (broadcast) {
      fieldsClassName += ' disabled-fields';
      title = broadcast && broadcast.title;
      url = broadcast.url;
      message = broadcast.contentText;
      duration = broadcast.duration;
    }

    return (
      <div className="community-broadcast sidebar-layout">
        <div className="main-content">
          {status === ERROR || error ? this.renderErrorMessage() : null}
          {this.renderTitle()}
          <div className={fieldsClassName}>
            <BroadcastTitle disabled={!!broadcast} value={title} validate={error} ref="title" />
            <BroadcastUrl value={url} disabled={!!broadcast} validate={error} ref="url" />
            <BroadcastMessage
              value={message}
              disabled={!!broadcast}
              validate={error}
              ref="message"
            />
            <BroadcastDuration value={duration} disabled={!!broadcast} ref="duration" />
          </div>
          {!broadcast ? (
            <button className="broadcast-button" onClick={this.openConfirmModal.bind(this)}>
              {status === LOADING ? <span className="spinner" /> : 'Send Broadcast'}
            </button>
          ) : null}
        </div>
        <BroadcastFAQ />
        <Modal ref="confirmationModal" className="confirm-modal">
          <ConfirmModal
            onClose={this.closeConfirmationModal.bind(this)}
            title="Confirm Action"
            onConfirm={this.handleClick.bind(this)}
            description="Are you sure you want to send this Broadcast?"
            buttonName="Send Broadcast"
          />
        </Modal>
        <Modal ref="stopModal" className="confirm-modal">
          <ConfirmModal
            onClose={this.closeStopModal.bind(this)}
            title="Confirm Action"
            onConfirm={this.handleStopClick.bind(this)}
            description="Are you sure you want to stop this Broadcast?"
            buttonName="Stop Broadcast"
          />
        </Modal>
      </div>
    );
  }
}

BroadcastComponent.propTypes = {
  spotId: PropTypes.string.isRequired,
  status: PropTypes.string,
  reason: PropTypes.string,
  broadcast: PropTypes.object,
  fetchBroadcast: PropTypes.func,
  newBroadcast: PropTypes.func,
  sendBroadcast: PropTypes.func,
  stopBroadcast: PropTypes.func
};

BroadcastComponent.displayName = 'Broadcast';

function mapStateToProps(state) {
  return {
    status: state.features.broadcast.status,
    reason: state.features.broadcast.reason,
    broadcast: state.features.broadcast.broadcast
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchBroadcast: () => dispatch(fetchBroadcast()),
    newBroadcast: () => dispatch(clearBroadcast()),
    sendBroadcast: payload => dispatch(createBroadcast(payload)),
    stopBroadcast: id => dispatch(stopBroadcastAction(id))
  };
}

export const Broadcast = connect(mapStateToProps, mapDispatchToProps)(BroadcastComponent);
